var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alertPromoCodeError"},[_c('img',{staticClass:"alertPromoCodeError__ico",attrs:{"src":require("assets/img/failure-mark.svg")}}),_vm._v(" "),_c('p',{staticClass:"alertPromoCodeError__text"},[_vm._v("\n    Не удалось применить скидку. "),_c('br'),_vm._v("Обратитесь к официанту\n  ")])])
}]

export { render, staticRenderFns }